import IEmpresas from "../interfaces/IEmpresas";
import IRelatorio_Colaboradores from "../interfaces/IRelatorio_Colaboradores";
import IReports from "../interfaces/IReports";
import { IPeriodo, IUsuario } from "../interfaces/IUsuario";
import { getEstadoCivil, getGrauInstrucao } from "../utilities/constantes";

const defaultProps: IReports = {
  // Configurações gerais do relatório
  config: {
    // Orientação da página: "portrait" (retrato) ou "landscape" (paisagem)
    orientation: "landscape",
    reportName: "Relatório de Funcionários Detalhado",
    // Modo de exibição das informações de página
    // "footer-simple": Exibe no rodapé "Página X de Y, Emitido por Operador - Em: Data - Hora"
    // "header-detailed": Exibe no cabeçalho "Pág.: X / Y, data: DD/MM/AAAA, hora: HH:MM, emitido por Operador"
    pageInfoMode: 'header-detailed',

    // Altura do cabeçalho em milímetros
    headerHeight: 35,
    
    // Altura do rodapé em milímetros
    footerHeight: 5,
    
    // Tamanho da fonte base em pontos
    fontSize: 10,
    
    // Tamanho da fonte do título em pontos
    titleFontSize: 14,
    
    // Tamanho da fonte dos detalhes em pontos
    detailFontSize: 10,
    
    // Família da fonte: "arial", "times", "courier", "calibri", "tahoma"
    fontFamily: "arial",
    
    // Alternar cores das linhas nas tabelas
    alternateRowColors: true,
    // Nota: O sistema usa fatores de utilização de espaço diferentes por orientação:
    // - 130% para orientação vertical (portrait)
    // - 110% para orientação horizontal (landscape)
    // Isso permite otimizar o uso do espaço disponível em cada página
    
    // Espaçamento interno das células em pontos
    cellPadding: 4,
    
    // Configuração do logo
    logo: {
      // URL do logo
      url: "https://exemplo.com/logo.png",
      
      // Tamanho do logo em milímetros
      size: 40,
      
      // Formato do logo: "square" (quadrado) ou "horizontal"
      format: "square",
      
      // Margem entre o logo e o texto do cabeçalho em milímetros
      textMargin: 5,
    },
    
    marginRight: 10,
    marginLeft: 10,
    marginTop: 5,
    marginBottom: 5,
  },
  
  // Linhas do cabeçalho
  headerLines: [],
  
  // Linhas do rodapé
  footerLines: [
    { text: "Documento Confidencial", align: "left" },
    { text: "Uso Interno", align: "left" },
  ],
  
  // Nome do operador que emitiu o relatório
  operatorName: "",
  
  // Conteúdo do relatório - Array com todos os elementos que compõem o relatório
  content: [],
}

const buildFuncionarioDetalhado = (data: IRelatorio_Colaboradores[], formData: any, empresaSelecionada?: IEmpresas, periodoSelecionado?: IPeriodo, usuario?: IUsuario): IReports => {

  const report: IReports = {
  ...defaultProps,
  config: {
    ...defaultProps.config,          
    logo: {
      url: empresaSelecionada?.Logo,
    },
  },
  headerLines:[
    { text: empresaSelecionada?.IdRelatorio, align: 'left' },
    { text: `Relação de Funcionários - Detalhado - ${periodoSelecionado?.Descricao}`, align: 'left' },
    { text: formData.ClassificadoPor == 'T+O' ? 'Organizado por Nº Ordem' : 'Organizado por Nome', align: 'left' },
  ],
  operatorName: usuario?.Nome,

  // Adiciona os conteúdos ao relatório
  // O conteúdo é um array de objetos que representam os elementos do relatório
  content: [    
    {
        compact: true,
        type: "table",
        id: `tabela-funcionario-detalhado`,
        columns: [          
          {
            name: "NOME <br/>MATRÍCULA <br/>ENDEREÇO <br/>E-mail",
            headerAlignment: 'left',
            dataAlignment: "left",
          },  
          {
            name: "C.P.F.<br/>R.G.<br/><br/>",
            headerAlignment: "left",
            dataAlignment: 'left',
            width: "8%",
          },  
          {
            name: "DATA NASC. <br/>FONE <br/>BAIRRO <br/>",
            headerAlignment: 'left',
            dataAlignment: "left",
            width: "10%",
          },   
          {
            name: "SEXO <br/>EST.CIVIL <br/>CEP <br/>",
            headerAlignment: 'left',
            dataAlignment: "left",
            width: "7%",
          },        
          {
            name: "DATA ADMIS.<br/>DATA DEMIS. <br/><br/>",
            headerAlignment: 'left',
            dataAlignment: "left",
            width: "9%",
          }, 
          {
            name: "TIP. FUNC.<br/><br/>CARGO <br/>",
            headerAlignment: 'left',
            dataAlignment: "left",            
            width: "15%",
          },  
          {
            name: "GR.INST<br/>CONTRATADO<br/><br/>",
            headerAlignment: 'left',
            dataAlignment: "left",
            width: "8%",
          },       
        ],
        data: data.map((item: any) => {
          const row = [];
          row.push(
            `${item.Nome}<br/>${item.Matricula}<br/>${item.Endereco}<br/>${item.Email}`,
            `${item.CPF}<br/>${item.RG}<br/><br/>`,
            `${item.DataNascimento}<br/>${item.Telefone}<br/>${item.Bairro}`,
            `${item.Sexo == 'M' ? 'Masculino' : 'Feminino'}<br/>${getEstadoCivil(item.EstadoCivil) || ''}<br/>${item.CEP || ''}`,
            `${item.DataAdmissao ? new Date(item.DataAdmissao).toLocaleDateString() : ''}<br/>${item.DataDemissao ? new Date(item.DataDemissao).toLocaleDateString() : ''}<br/>`,
            `${item.TipoFuncionario}<br/><br/>${item.Cargo}`,
            `${getGrauInstrucao(item.GrupoInstrucao)}<br/>${item.Contratado}<br/><br/>`
          );

          return row;
        })
      }]
  };

  return report;
}

export default buildFuncionarioDetalhado;